"use client";

interface StepDotsProps {
  steps: string[];
  current: number;
}

export function StepDots({ steps, current }: StepDotsProps) {
  return (
    <div className="flex items-center gap-3">
      {steps.map((label, i) => (
        <div key={label} className="flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full transition-all duration-200"
            style={{
              backgroundColor: i <= current ? "var(--color-accent)" : "rgba(255,255,255,0.1)",
              boxShadow: i === current ? "0 0 8px rgba(124,106,239,0.4)" : "none",
            }}
          />
          <span
            className="text-[10px] font-medium transition-colors duration-200"
            style={{ color: i <= current ? "var(--color-accent-bright)" : "#5c5672" }}
          >
            {label}
          </span>
          {i < steps.length - 1 && (
            <div
              className="w-6 h-px ml-1"
              style={{
                backgroundColor: i < current ? "rgba(124,106,239,0.4)" : "rgba(255,255,255,0.06)",
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
